export type OrderKind = "new" | "in-progress" | "past";

export interface OrderLike {
  status: string;
  supplierQuoteStatus: string;
}

const PAST_STATUSES = new Set([
  "Delivered",
  "Installed",
  "Complete paid",
  "delivered",
]);

/** Each order lands in exactly one bucket: past > new > in-progress. */
export function orderKindOf(est: OrderLike): OrderKind {
  if (PAST_STATUSES.has(est.status)) return "past";
  if (est.supplierQuoteStatus === "pending") return "new";
  return "in-progress";
}

export function filterByKind<T extends OrderLike>(list: T[], kind: OrderKind): T[] {
  return list.filter((est) => orderKindOf(est) === kind);
}

const CONTROL_LABELS: Record<string, string> = {
  manual: "Manual",
  cordless: "Cordless",
  motorized: "A-OK Matter motorized",
};

export function controlLabel(control?: string): string {
  if (!control) return "—";
  return (
    CONTROL_LABELS[control] ??
    control.charAt(0).toUpperCase() + control.slice(1)
  );
}

export function shadingLabel(shading?: string): string {
  if (!shading) return "—";
  return shading === "blackout" ? "Blackout" : "Semi blackout";
}

export interface ShadingSource {
  roomName: string;
  windowLabel: string;
  type?: string;
}

/** Map of "room::window" → shading type, taken from the estimate items. */
export function shadingByWindow(items: ShadingSource[]): Map<string, string> {
  const map = new Map<string, string>();
  for (const item of items) {
    if (item.type) map.set(`${item.roomName}::${item.windowLabel}`, item.type);
  }
  return map;
}
